/*global process*/

const backend = 'https://api.jabrutouch.com'

const paymentBackend = process.env.NODE_ENV == 'development'? 'http://tashema.test' : 'https://donate.jabrutouch.com'
export default {
    backendDeliveryUrl: `${backend}/api/delivery/spaces/1`,
    backendUrl: `${backend}/api/spaces/1`,
    backendAppSpecificUrl: `${backend}/api/jabrutouch`,
    deliveryToken: 'a63p1n4ujf13hsd4mf8mgfkncp',
    appBackendUrl: 'https://jabrutouch.ravtech.co.il/api/',
    paymentBackendUrl: `${paymentBackend}/jabrutouch`
}